import * as yup from 'yup'

export class ForgotPasswordDto {
  email?: string = undefined
}

export const forgotPasswordValidationSchema = yup.object({
  email: yup.string().email('Email').required('Field is required')
})
